export class InfoPointPopupfileView {
    async createView() {
        const element = document.createElement('infopoint-popupfile');
        return element;
    }
}
//# sourceMappingURL=infopoint-filepopupview.js.map